import React, { useState } from "react"
import { Backdrop, CircularProgress } from "@material-ui/core"
import './SharingRedirect.css'
import { getClientStyle } from './helpers/GetClientStyle'
import { checkIfClientHasMobileApp } from './helpers/CheckIfClientHasMobileApp'
import { isAndroid, isIOS } from 'react-device-detect'
import CloseIcon from '@material-ui/icons/Close'
import { generateRedirectUrl } from './helpers/GenerateRedirectUrl'

export const SharingRedirect = ({ mobileStatus, dismissMobileMessage, messageDismissed }) => {
    const url = new URL(window.location.href)

    // eslint-disable-next-line
    const [x, vodType, client, contentType, contentID] = url.pathname.split('/')

    const [status, setStatus] = useState('App') // Store Loading

    if (!mobileStatus || !checkIfClientHasMobileApp(client)) return <></>

    const clientStyle = getClientStyle(client)

    const urlParams = new URLSearchParams(url.search)

    const params = {}

    urlParams.forEach((value, key) => {
        params[key] = value
    })

    const backdropStyle = {
        zIndex: 5000,
        backgroundColor: 'rgba(0,0,0,0.85)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center'
    }

    const backdropContentContainer = { 
        backgroundColor: clientStyle.background 
    }

    const handleRedirect = () => {
        if (status === 'Loading') return
        
        // const userAgent = navigator.userAgent || navigator.vendor || window.opera

        let operatingSystem

        if (isAndroid) operatingSystem = 'android'
        else if (isIOS) operatingSystem = 'ios'
        else return //! handle no operating system or OS that is not android/ios
        
        const [schemeLink, storeLink] = generateRedirectUrl(operatingSystem, params, clientStyle.scheme, client, clientStyle.packageName, clientStyle.appID)
        
        if (status === 'App') {
            try {
                setStatus('Loading')
                const removePrePath = window.location.href.replace(/^(.*):\/\/[^\/]+/, '') // Removes scheme and domain
                window.location.href = `${clientStyle.scheme}://ext${removePrePath}`
    
                setTimeout(() => {
                    if (document.visibilityState === 'visible') {
                        window.location.href = storeLink
                        setStatus('Store')
                    } else setStatus('App')
                }, 3000)
            } catch (error) {
                console.log('redirect error:', error)
            }
        } else if (status === 'Store') {
            try {
                setStatus('Loading')
                window.location.href = storeLink
    
                setTimeout(() => {
                    setStatus('App')
                }, 3000)
            } catch (error) {
                console.log('redirect error:', error)
            }
        }
    }

    const iconUrl = `https://vod-mobile-redirect-icons.s3.us-west-2.amazonaws.com/${client}.png`

    const MobileAppIcon = () => <img onClick={handleRedirect} src={iconUrl} className="mobile-backdrop-icon" alt='mobile app icon' />

    const MobileAppHeader = () => {
        const topMessage = status === 'Loading' ? '' : status === 'App' ? 'This content looks better in the' : 'Do you have the'
        const bottomMessage = status === 'Loading' ? '' : status === 'App' ? 'Mobile App' : 'Mobile App installed?'
        return (
            <div onClick={handleRedirect} className="mobile-backdrop-header" style={{ color: clientStyle.textColor }}>
                <div>{topMessage}</div>
                <div className="mobile-backdrop-header-brand">{status === 'Loading' ? '' : clientStyle.appName}</div>
                <div>{bottomMessage}</div>
            </div>
        )
    }
    
    const MobileAppRedirectButton = () => {
        const buttonMessage = status === 'App' ? 'Take me there!' : status === 'Loading' ? <CircularProgress style={{ marginTop: '10px' }} color='inherit' size='24px' /> : 'Install it here!'
        return (
            <div onClick={handleRedirect} style={{ backgroundColor: clientStyle.buttonBackground || 'white', color: clientStyle.buttonText || 'black' }} className="mobile-backdrop-redirect-button">{buttonMessage}</div>
        )
    }

    // const CloseButton = () => <div className="mobile-backdrop-close-button" onClick={dismissMobileMessage}>Close</div>
    // {/* <CloseButton /> */}
    const AdditionalCloseButton = () => status === 'Loading' ? <></> : <div style={{ color: clientStyle.closeIcon || 'rgba(255, 255, 255, 0.1)' }} onClick={dismissMobileMessage} className="mobile-backdrop-additional-close-button"><CloseIcon color='inherit' /></div>

    return (
        <Backdrop style={backdropStyle} open={!messageDismissed} transitionDuration={350}>
            <div className="mobile-backdrop-container" style={backdropContentContainer}>
                <MobileAppIcon />
                <MobileAppHeader />
                <MobileAppRedirectButton />
                <AdditionalCloseButton />
            </div>
        </Backdrop>
    )
}
